<template>
    <div>
        <div>Hello World DashboardLanding</div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
    name: "DashboardLanding",
    data: () => ({}),
    methods: {},
    onMounted() {
        console.log("DashboardLanding mounted");
    },
});

</script>
